export const MAX_TRANSFER_AUDIO_BYTES = 2 * 1024 * 1024;

export const ACCEPTED_TRANSFER_AUDIO_EXTENSIONS = ['.wav', '.mp3'];

export const TRANSFER_AUDIO_ACCEPT = [
    ...ACCEPTED_TRANSFER_AUDIO_EXTENSIONS,
    'audio/wav',
    'audio/x-wav',
    'audio/mpeg',
    'audio/mp3',
].join(',');

const TRANSFER_AUDIO_FILE_NAME_FALLBACK = 'Custom clip';

// Mirrors the server limits so the user hears about them before the upload;
// the server's magic-byte check stays the real one.
export const validateTransferAudioFile = (file: File): string | null => {
    const name = file.name.toLowerCase();
    if (!ACCEPTED_TRANSFER_AUDIO_EXTENSIONS.some((extension) => name.endsWith(extension))) {
        return 'Transfer audio must be a WAV or MP3 file.';
    }
    if (file.size === 0) {
        return 'This file is empty.';
    }
    if (file.size > MAX_TRANSFER_AUDIO_BYTES) {
        return 'Transfer audio must be 2 MB or smaller.';
    }
    return null;
};

export const transferAudioFileName = (key?: string): string => {
    return key?.split('/').pop() || TRANSFER_AUDIO_FILE_NAME_FALLBACK;
};
